import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Download = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 14 12">
      <path d="M10.2078421,6.26530421 L9.68689474,5.73507078 L7.36805263,8.09449705 L7.36805263,0 L6.63121053,0 L6.63121053,8.09449705 L4.31310526,5.73507078 L3.79215789,6.26530421 L6.99963158,9.53070217 L10.2078421,6.26530421 Z M13.2631579,8.25011718 L13.2631579,11.2500234 L0.736842105,11.2500234 L0.736842105,8.25011718 L0,8.25011718 L0,12 L14,12 L14,8.25011718 L13.2631579,8.25011718 Z" />
    </svg>
  );
};

Download.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Download;
